import { html, ifDefined } from "../../.."
import { isIOS, T } from "../../../global/globals"
import { SnackAdd } from "../../snackapi"
import { FieldSetVal } from "../fieldapi"
import { FormGet } from "../formapi"
import { _setFieldFocus } from "../helper"
import { _focusOutHelper } from "./helpers"
import { SYSControlBase } from "./syscontrolbase"

export let debounceInfo = { inputDebounce: 0 }

export class SYSTextbox extends SYSControlBase {
  // change is important for eg. autofilled form inputs

  clearDebounce() {
    if (debounceInfo.inputDebounce) {
      clearTimeout(debounceInfo.inputDebounce)
    }
  }

  handleChange(e: Event) {
    if (!this.field._state.valueChangedHandled) {
      this.clearDebounce()

      this.field._state.valueChangedHandled = true
      this.actions.ovl.form._ChangeField({
        fieldKey: this.field.fieldKey,
        formState: this.formState,
        value: this.inputElement.value,
        isInnerEvent: false,
        watched: true,
        noRetrigger: true,
      })
    }
  }

  async handleInput(e: KeyboardEvent) {
    const changeField = () => {
      this.actions.ovl.form._ChangeField({
        fieldKey: this.field.fieldKey,
        formState: this.formState,
        value: this.inputElement.value,
        isInnerEvent: true,
        watched: true,
        noRetrigger: true,
      })
      //this.field._state.valueChangedHandled = false
    }

    if (this.field.ui.inputDebounceMS) {
      this.clearDebounce()
      this.field.value = this.inputElement.value
      debounceInfo.inputDebounce = setTimeout(() => {
        changeField()
      }, this.field.ui.inputDebounceMS)
    } else {
      changeField()
    }
  }

  async getUI() {
    let visible = super.InitControl()
    if (visible === false) {
      return undefined
    }
    let field = this.field
    let readonly = this.getReadOnly()
    let pattern
    let inputMode: any = "text"
    if (field.ui.inputMode) {
      inputMode = field.ui.inputMode
    } else {
      if (field.type === "decimal") {
        inputMode = "decimal"
      } else if (field.type === "int") {
        inputMode = "numeric"
      }
    }
    if (isIOS()) {
      if (inputMode === "numeric") {
        pattern = "[0-9]*"
      } else if (inputMode === "decimal") {
        pattern = "\\d*"
      }
    }
    let type = "text"
    if (field.ui && field.ui.isPassword) {
      let displayPw =
        FormGet("SYSPasswordVisibility").formState?.fields["VisiblePw"]
          .convertedValue === true
      if (!displayPw) {
        type = "password"
      }
    }
    // this shouldn't be necessary
    // if (isIOS() && (field.type === "decimal" || field.type === "int")) {
    //   console.log("Set to number")
    //   type = "number"
    // }

    let nullClicker = html`<span></span>`
    let isNullInput = ""
    if (field.nullHandling.enabled && field.convertedValue !== null) {
      isNullInput = "ovl-null-input"
      nullClicker = html`
        <span
          title="${T("SYSSetToNull")}"
          class="sap-icon--sys-cancel-2"
          role="presentation"
          @click=${(e) => {
            e.stopPropagation()
            FieldSetVal(field, null, { watched: true })
          }}
        ></span>
      `
    }

    let value = this.getHookValue()
    if (!field.editor) {
      value = html`
        <input
          tabindex="${readonly ? "-1" : "0"}"
          @focusout=${(e) => {
            // // because change event does not work when changing from "" to null
            // // but if a changed was already fired before we set the handled to true so it doesn't fire again
            // // but we should also call (fire) changefield if the field was not valid before.
            // // because it could be set with Context "Validate" by a ValueChanged hook.
            // // (it could run into the FormChanged Hook clearing validations which it shouldn't)
            // this.clearDebounce()
            // console.log("2", this.field._state.valueChangedHandled)
            // if (
            //   (!field._state.valueChangedHandled &&
            //     field._state.valueAfterGotFocus !== field.value) ||
            //   !field.previousValid
            // ) {
            //   this.actions.ovl.form._ChangeField({
            //     fieldKey: this.field.fieldKey,
            //     formState: this.formState,
            //     value: this.inputElement.value,
            //     watched: true,
            //     noRetrigger: true,
            //   })
            // }
            _focusOutHelper(e, this.field)
          }}
          @focus=${() => {
            this.field._state.valueAfterGotFocus = field.value
            this.field._state.valueChangedHandled = false
            _setFieldFocus(this.field, true)
          }}
          placeholder=${ifDefined(
            this.field.ui.infoValue ? this.field.ui.infoValue : undefined
          )}
          @input=${(e) => this.handleInput(e)}
          @change=${(e) => this.handleChange(e)}
          autocomplete=${field.ui.autocomplete === "off"
            ? "one-time-code"
            : field.ui.autocomplete}
          name="${field.ui.autocomplete !== "off"
            ? field.ui.autocomplete
            : "search_ios_autocomplete_hack"}"
          spellcheck=${field.ui.useSpellcheck ? "true" : "false"}
          inputmode=${inputMode}
          pattern=${ifDefined(pattern)}
          ?readonly=${readonly}
          class=${`fd-input  __inpfocbox ${this.getInputClass(
            "textbox",

            this.customInfo.customRowClassName
          )}`}
          type=${type}
          id=${field.id}
          value=${field.value}
        />
      `
    } else {
      value = html`<div
        @focusout=${(e) => {
          _focusOutHelper(e, this.field)
        }}
        @focus=${() => {
          _setFieldFocus(this.field, true)
        }}
        id=${field.id}
        ?readonly=${readonly}
        tabindex="0"
        class=${`fd-input  ovledit-value __inpfocbox ${this.getInputClass(
          "textbox",

          this.customInfo.customRowClassName
        )}`}
      >
        ${value}
      </div>`
    }

    return html`
      <div
        class="${this.getContainerClass(
          "textbox",

          this.customInfo.customRowClassContainerName
        )}"
      >
        <ovl-controllabel .props=${() => this.field}> </ovl-controllabel>
        <div class=${`ovl-formcontrol-value ${isNullInput}`}>
          ${value} ${nullClicker}
        </div>

        <ovl-controlcustomhint .props=${() => this.field}>
        </ovl-controlcustomhint>
        <ovl-controlvalidationhint .props=${() => this.field}>
        </ovl-controlvalidationhint>
      </div>
    `
  }
  async afterRender() {
    this.inputElement = document.getElementById(this.field.id)
    if (this.inputElement && this.inputElement.value !== this.field.value) {
      this.inputElement.value = this.field.value

      if (isIOS() && this.field.value === null) {
        this.inputElement.value = ""
      }
    }
    await super.afterRender()
  }
  async disconnectedCallback() {
    this.inputElement = null
    await super.disconnectedCallback()
  }
}
